// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_singleTranscript__k50H\\+ {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.styles_singleTranscript__k50H\\+:hover {
  color: #6ba7a8;
  background-color: rgba(0, 0, 0, 0.04);
}
.styles_singleTranscript__k50H\\+ .styles_header__OkzC9 {
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles_singleTranscript__k50H\\+ div {
  display: flex;
  width: 100%;
  align-items: center;
}
.styles_singleTranscript__k50H\\+ .styles_title__h0idP {
  grid-column: span 4;
  display: flex;
  flex-wrap: wrap;
  color: #6ba7a8;
  line-height: 1.4;
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .styles_singleTranscript__k50H\\+ .styles_title__h0idP {
    grid-column: span 3;
  }
}
.styles_singleTranscript__k50H\\+ .styles_title__h0idP.styles_header__OkzC9 {
  color: #fff;
  font-weight: 600;
}
.styles_singleTranscript__k50H\\+ .styles_status__0lP25 {
  display: flex;
  font-size: 12px;
  padding: 8px 12px;
  color: #fff;
  width: max-content;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  margin: 0 auto;
}
@media screen and (min-width: 768px) {
  .styles_singleTranscript__k50H\\+ .styles_status__0lP25 {
    font-size: 13px;
    margin: unset;
  }
}
.styles_singleTranscript__k50H\\+ .styles_status__0lP25.styles_complete__x6yQp {
  background-color: rgba(76, 187, 23, 0.7);
}
.styles_singleTranscript__k50H\\+ .styles_status__0lP25.styles_toReview__yLLpq {
  background-color: rgba(107, 167, 168, 0.7);
}
.styles_singleTranscript__k50H\\+ .styles_status__0lP25.styles_generating__ONzQZ {
  background-color: rgba(121, 37, 199, 0.7);
}
.styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz {
  display: flex;
  justify-content: flex-end;
}
.styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz .styles_itemBtn__PE\\+Wk {
  color: #fff;
  font-weight: 600;
  background-color: #6ba7a8;
  border: 1px;
  border-radius: 4rem;
  cursor: pointer;
  padding: 4px 7px 4px 8px;
  transition: all 0.3s ease;
  box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);
}
.styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz .styles_itemBtn__PE\\+Wk:hover {
  opacity: 0.8;
}
@media screen and (min-width: 768px) {
  .styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz .styles_itemBtn__PE\\+Wk {
    padding: 8px 13px 8px 16px;
  }
}
.styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz .styles_itemBtn__PE\\+Wk img {
  width: 12px;
}
@media screen and (min-width: 768px) {
  .styles_singleTranscript__k50H\\+ .styles_columnBtn__ECqrz .styles_itemBtn__PE\\+Wk img {
    width: 16px;
  }
}

.styles_single__-2lKa {
  display: flex;
  flex-direction: column;
  padding: 12px;
  justify-content: space-between;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  gap: 16px;
}
.styles_single__-2lKa .styles_content__kVjY6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_status__0lP25 {
  display: flex;
  font-size: 12px;
  padding: 8px 12px;
  color: #fff;
  width: max-content;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  margin: 12px 0;
}
@media screen and (min-width: 768px) {
  .styles_single__-2lKa .styles_content__kVjY6 .styles_status__0lP25 {
    font-size: 13px;
  }
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_status__0lP25.styles_complete__x6yQp {
  background-color: rgba(76, 187, 23, 0.7);
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_status__0lP25.styles_toReview__yLLpq {
  background-color: rgba(107, 167, 168, 0.7);
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_status__0lP25.styles_generating__ONzQZ {
  background-color: rgba(121, 37, 199, 0.7);
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_title__h0idP {
  font-weight: 600;
  color: #6ba7a8;
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_tags__mSeq3 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_tags__mSeq3 .styles_tag__JJHTn {
  padding: 3px 6px;
  font-size: 12px;
  background-color: #6ba7a8;
  color: #fff;
  font-weight: 600;
  border-radius: 12px;
}
.styles_single__-2lKa .styles_content__kVjY6 .styles_date__Z3QM1 {
  font-weight: 600;
  font-size: 14px;
  text-decoration: underline;
}
.styles_single__-2lKa .styles_buttons__81m5t {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.styles_single__-2lKa .styles_buttons__81m5t a {
  background-color: #6ba7a8;
  padding: 4px 7px 4px 8px;
}
@media screen and (min-width: 768px) {
  .styles_single__-2lKa .styles_buttons__81m5t a {
    padding: 6px 11px 6px 14px;
  }
}
.styles_single__-2lKa .styles_buttons__81m5t button {
  background-color: rgba(255, 0, 0, 0.7);
  padding: 4px 7px 4px 7px;
}
@media screen and (min-width: 768px) {
  .styles_single__-2lKa .styles_buttons__81m5t button {
    padding: 6px 11px 6px 11px;
  }
}
.styles_single__-2lKa .styles_buttons__81m5t a, .styles_single__-2lKa .styles_buttons__81m5t button {
  color: #fff;
  font-weight: 600;
  border: 1px;
  border-radius: 4rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);
}
.styles_single__-2lKa .styles_buttons__81m5t a:hover, .styles_single__-2lKa .styles_buttons__81m5t button:hover {
  opacity: 0.8;
}
.styles_single__-2lKa .styles_buttons__81m5t a img, .styles_single__-2lKa .styles_buttons__81m5t button img {
  width: 12px;
}
@media screen and (min-width: 768px) {
  .styles_single__-2lKa .styles_buttons__81m5t a img, .styles_single__-2lKa .styles_buttons__81m5t button img {
    width: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptList/TranscriptItem/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,yBAAA;EACA,oCAAA;AACF;AACE;EACE,cAAA;EACA,qCAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAJ;AAGE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAGI;EAPF;IAQI,mBAAA;EAAJ;AACF;AAEI;EACE,WAAA;EACA,gBAAA;AAAN;AAIE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oFAAA;EAEA,cAAA;AAHJ;AAKI;EAZF;IAaI,eAAA;IACA,aAAA;EAFJ;AACF;AAII;EACE,wCAAA;AAFN;AAII;EACE,0CAAA;AAFN;AAII;EACE,yCAAA;AAFN;AAME;EACE,aAAA;EACA,yBAAA;AAJJ;AAMI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,kDAAA;AAJN;AAKM;EACE,YAAA;AAHR;AAMM;EAdF;IAeI,0BAAA;EAHN;AACF;AAKM;EACE,WAAA;AAHR;AAKQ;EAHF;IAII,WAAA;EAFR;AACF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,oCAAA;EACA,SAAA;AALF;AAQE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANJ;AAQI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oFAAA;EAEA,cAAA;AAPN;AASM;EAZF;IAaI,eAAA;EANN;AACF;AAQM;EACE,wCAAA;AANR;AAQM;EACE,0CAAA;AANR;AAQM;EACE,yCAAA;AANR;AAUI;EACE,gBAAA;EACA,cAAA;AARN;AAWI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AATN;AAWM;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,eAAA;EACA,0BAAA;AAXN;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAbJ;AAeI;EACE,yBAAA;EACA,wBAAA;AAbN;AAcM;EAHF;IAII,0BAAA;EAXN;AACF;AAcI;EACE,sCAAA;EACA,wBAAA;AAZN;AAaM;EAHF;IAII,0BAAA;EAVN;AACF;AAaI;EACE,WAAA;EACA,gBAAA;EAEA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kDAAA;AAZN;AAaM;EACE,YAAA;AAXR;AAcM;EACE,WAAA;AAZR;AAcQ;EAHF;IAII,WAAA;EAXR;AACF","sourcesContent":[".singleTranscript {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n\n  &:hover {\n    color: #6ba7a8;\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  div {\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n\n  .title {\n    grid-column: span 4;\n    display: flex;\n    flex-wrap: wrap;\n    color: #6ba7a8;\n    line-height: 1.4;\n    font-weight: 500;\n    @media screen and (min-width: 768px) {\n      grid-column: span 3;\n    }\n\n    &.header {\n      color: #fff;\n      font-weight: 600;\n    }\n  }\n\n  .status {\n    display: flex;\n    font-size: 12px;\n    padding: 8px 12px;\n    color: #fff;\n    width: max-content;\n    border-radius: 4px;\n    font-weight: 600;\n    box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,\n      rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n    margin: 0 auto;\n\n    @media screen and (min-width: 768px) {\n      font-size: 13px;\n      margin: unset;\n    }\n\n    &.complete {\n      background-color: rgba(76, 187, 23, 0.7);\n    }\n    &.toReview {\n      background-color: rgba(107, 167, 168, 0.7);\n    }\n    &.generating {\n      background-color: rgba(121, 37, 199, 0.7);\n    }\n  }\n\n  .columnBtn {\n    display: flex;\n    justify-content: flex-end;\n\n    .itemBtn {\n      color: #fff;\n      font-weight: 600;\n      background-color: #6ba7a8;\n      border: 1px;\n      border-radius: 4rem;\n      cursor: pointer;\n      padding: 4px 7px 4px 8px;\n      transition: all 0.3s ease;\n      box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);\n      &:hover {\n        opacity: 0.8;\n      }\n\n      @media screen and (min-width: 768px) {\n        padding: 8px 13px 8px 16px;\n      }\n\n      img {\n        width: 12px;\n\n        @media screen and (min-width: 768px) {\n          width: 16px;\n        }\n      }\n    }\n  }\n}\n\n.single{\n  display: flex;\n  flex-direction: column;\n  padding:12px;\n  justify-content: space-between;\n  border-radius: 12px;\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  gap: 16px;\n\n\n  .content{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .status {\n      display: flex;\n      font-size: 12px;\n      padding: 8px 12px;\n      color: #fff;\n      width: max-content;\n      border-radius: 4px;\n      font-weight: 600;\n      box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,\n        rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n      margin: 12px 0;\n  \n      @media screen and (min-width: 768px) {\n        font-size: 13px;\n      }\n  \n      &.complete {\n        background-color: rgba(76, 187, 23, 0.7);\n      }\n      &.toReview {\n        background-color: rgba(107, 167, 168, 0.7);\n      }\n      &.generating {\n        background-color: rgba(121, 37, 199, 0.7);\n      }\n    }\n\n    .title{\n      font-weight: 600;\n      color: #6ba7a8;\n    }\n\n    .tags{\n      display: flex;\n      flex-wrap: wrap;\n      gap: 4px;\n      align-items: center;\n\n      .tag{\n        padding: 3px 6px;\n        font-size: 12px;\n        background-color: #6ba7a8;\n        color: #fff;\n        font-weight: 600;\n        border-radius: 12px;\n      }\n    }\n\n    .date{\n      font-weight: 600;\n      font-size: 14px;\n      text-decoration: underline;\n    }\n  }\n\n  .buttons{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    a{\n      background-color: #6ba7a8;\n      padding: 4px 7px 4px 8px;\n      @media screen and (min-width: 768px) {\n        padding: 6px 11px 6px 14px;\n      }\n    }\n\n    button{\n      background-color: rgba(255, 0, 0, 0.7);\n      padding: 4px 7px 4px 7px;\n      @media screen and (min-width: 768px) {\n        padding: 6px 11px 6px 11px;\n      }\n    }\n\n    a, button {\n      color: #fff;\n      font-weight: 600;\n      \n      border: 1px;\n      border-radius: 4rem;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);\n      &:hover {\n        opacity: 0.8;\n      }\n\n      img {\n        width: 12px;\n\n        @media screen and (min-width: 768px) {\n          width: 16px;\n        }\n      }\n    }\n    \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleTranscript": `styles_singleTranscript__k50H+`,
	"header": `styles_header__OkzC9`,
	"title": `styles_title__h0idP`,
	"status": `styles_status__0lP25`,
	"complete": `styles_complete__x6yQp`,
	"toReview": `styles_toReview__yLLpq`,
	"generating": `styles_generating__ONzQZ`,
	"columnBtn": `styles_columnBtn__ECqrz`,
	"itemBtn": `styles_itemBtn__PE+Wk`,
	"single": `styles_single__-2lKa`,
	"content": `styles_content__kVjY6`,
	"tags": `styles_tags__mSeq3`,
	"tag": `styles_tag__JJHTn`,
	"date": `styles_date__Z3QM1`,
	"buttons": `styles_buttons__81m5t`
};
export default ___CSS_LOADER_EXPORT___;
